// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
import SvgIconStyle from '../../../components/SvgIconStyle';
import { UserRole } from 'src/hooks/useAuth';

// ----------------------------------------------------------------------

const getIcon = (name: string) => (
  <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);


const ICONS = {
  account: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  products: getIcon('ic_cart'),
  users: getIcon('ic_user'),
  companies: getIcon('ic_banking'),
  orders: getIcon('ic_invoice'),
  vehicles: getIcon('ic_vehicle'),
  workers: getIcon('ic_booking'),
  newsLetters: getIcon('ic_blog'),
  subscriptions: getIcon('ic_calendar'),
};

const rolePermissions: Record<UserRole, string[]> = {
  [UserRole.ADMIN]: [
    'Dashboard',
    'Products',
    'Companies',
    'Users',
    'Orders',
    'Vehicles',
    'Workers',
    'NewsLetters',
    'Reports',
    'Subscriptions',
  ],
  [UserRole.DISTRIBUTOR]: [
    'Dashboard',
    'Companies',
    'Users',
    'Orders',
    'Vehicles',
    'Workers',
    'Account',
  ],
  [UserRole.RETAILER]: ['Dashboard', 'Orders', 'Account'],
  [UserRole.STAFF]: ['Orders'],
};

const baseNavConfig = [
  {
    subheader: 'Main',
    items: [
      { title: 'Dashboard', path: PATH_DASHBOARD.general.app, icon: ICONS.dashboard },
    ],
  },
  {
    subheader: 'Management',
    items: [
      {
        title: 'Products',
        path: PATH_DASHBOARD.products.root,
        icon: ICONS.products,
      },
      {
        title: 'Companies',
        path: PATH_DASHBOARD.companies.root,
        icon: ICONS.companies,
      },
      {
        title: 'Users',
        path: PATH_DASHBOARD.users.root,
        icon: ICONS.users,
      },
      {
        title: 'Orders',
        path: PATH_DASHBOARD.orders.root,
        icon: ICONS.orders,
      },
      {
        title: 'Vehicles',
        path: PATH_DASHBOARD.vehicles.root,
        icon: ICONS.vehicles,
      },
      {
        title: 'Workers',
        path: PATH_DASHBOARD.workers.root,
        icon: ICONS.workers,
      },
      {
        title: 'NewsLetters',
        path: PATH_DASHBOARD.newsletters.root,
        icon: ICONS.newsLetters,
      },
      {
        title: 'Account',
        path: PATH_DASHBOARD.account.root,
        icon: ICONS.account,
      },
      {
        title: 'Reports',
        path: PATH_DASHBOARD.account.reports,
        icon: ICONS.account,
      },
      {
        title: 'Subscriptions',
        path: PATH_DASHBOARD.subscriptions.root,
        icon: ICONS.subscriptions,
      },
    ],
  },
];

const navConfig = (role: UserRole | null, hasAccountRights: boolean = false) => {
  if (!role) {
    return []; // Return empty config if no role is provided (e.g., unauthenticated user)
  }

  const allowedItems = rolePermissions[role] || [];

  return baseNavConfig
    .map((section) => ({
      ...section,
      items: section.items.filter((item) => {
        // Check if item is in allowed items
        if (!allowedItems.includes(item.title)) return false;

        // Special handling for Account - only show if user has account rights
        if (item.title === 'Account') {
          return hasAccountRights;
        }

        return true;
      }),
    }))
    .filter((section) => section.items.length > 0); // Remove sections with no items
};

export default navConfig;
